<template>
    <BreadCrumb PageTitle="Ajouter une tarification" />
    <AddModalTarification/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import AddModalTarification from "@/components/Tarification/AddModalTarification.vue";
  
    export default defineComponent({
      name: "AddTarificationPage",
      components: {
        BreadCrumb,
        AddModalTarification,
      },
    });
  </script>